import {VersionVariants} from '@jobseeker/lotus/enums';
import dynamic from 'next/dynamic';
import {AlertProps as MuiAlertProps} from '@mui/material';
import NotImplemented from '@jobseeker/lotus/elements/NotImplemented';
import V2 from './V2';

type OmmitedMuiProps = Omit<MuiAlertProps, 'variant'>;
export interface AlertProps extends OmmitedMuiProps {
  variant: VersionVariants;
  show: boolean;
  actionUrl?: string;
  actionLabel?: string;
  container?: any;
  background?: string;
  whiteCross?: boolean;
  width?: string;
}
const componentMap: any = {};
componentMap[VersionVariants.VERSION_ONE] = NotImplemented;
componentMap[VersionVariants.VERSION_TWO] = V2;

const Alert = (props: AlertProps) => {
  let Component;
  if (Object.keys(componentMap).includes(props.variant)) {
    Component = componentMap[props.variant];
  } else {
    Component = componentMap[VersionVariants.VERSION_ONE];
  }
  return <Component {...props} />;
};

export default Alert;
